import { MessageCircle } from "lucide-react";

const CHANNEL_URL = process.env.REACT_APP_WHATSAPP_CHANNEL_URL || "";

const LABEL = "Daily Sarkari updates on WhatsApp";

const VARIANTS = {
  // Compact green pill used in headers / nav
  header:
    "inline-flex items-center gap-2 h-9 px-3 rounded-full bg-green-600 hover:bg-green-700 text-white text-xs font-semibold whitespace-nowrap transition-colors shadow-sm",
  // Mobile-menu full width row
  mobile:
    "flex items-center justify-center gap-2 w-full min-h-11 px-4 rounded-md bg-green-600 hover:bg-green-700 text-white text-sm font-semibold transition-colors",
  // In-article / in-page banner
  banner:
    "flex items-center justify-between gap-3 w-full px-4 py-3 rounded-lg bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white shadow-sm transition-colors",
};

export default function WhatsAppPill({ variant = "header", className = "", testId }) {
  // If channel URL not configured yet, render nothing — so the live site
  // never shows a broken "#" link. Update REACT_APP_WHATSAPP_CHANNEL_URL
  // in frontend/.env once the channel link is created.
  if (!CHANNEL_URL) return null;

  const cls = `${VARIANTS[variant] || VARIANTS.header} ${className}`.trim();

  if (variant === "banner") {
    return (
      <a
        href={CHANNEL_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={cls}
        data-testid={testId || "whatsapp-channel-banner"}
        aria-label={LABEL}
      >
        <span className="flex items-center gap-3">
          <span className="grid place-items-center w-10 h-10 rounded-full bg-white/15">
            <MessageCircle className="w-5 h-5" aria-hidden="true" />
          </span>
          <span className="leading-tight">
            <span className="block text-sm font-bold">{LABEL}</span>
            <span className="block text-xs text-green-50/90">
              Notifications, admit cards & results — direct to your phone.
            </span>
          </span>
        </span>
        <span className="hidden sm:inline text-xs font-bold uppercase tracking-wider bg-white/20 px-3 py-1.5 rounded-md">
          Follow →
        </span>
      </a>
    );
  }

  return (
    <a
      href={CHANNEL_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={cls}
      data-testid={testId || `whatsapp-channel-${variant}`}
      aria-label={LABEL}
    >
      <MessageCircle className="w-4 h-4" aria-hidden="true" />
      <span>{variant === "mobile" ? LABEL : "WhatsApp updates"}</span>
    </a>
  );
}
